/**
 * 是否存在目标key
 * @param {*} obj 
 * @param {*} targetKey 
 * @returns 
 */
export function hasTargetKey(obj, targetKey) {
  // 遍历对象的所有属性
  for (const key in obj) {
    // 如果当前属性是一个对象，递归调用hasKey检查子对象
    if (typeof obj[key] === 'object' && obj[key] !== null) {
      if (hasTargetKey(obj[key], targetKey)) {
        return true
      }
    }
    // 检查当前属性是否是目标key
    if (key === targetKey) {
      return true
    }
  }
  // 如果遍历完所有属性都没有找到目标key，返回false
  return false
}
